import React from 'react';

class TextWithBullets extends React.Component {
    lines;
    constructor(props) {
        super(props);
        this.lines = this.props.inputText ? this.props.inputText.split(/(?=\*)/g).map((l) => l.trim()) : [];
        this.getBulletListItemsAfterIndex = this.getBulletListItemsAfterIndex.bind(this);
    }

    getBulletListItemsAfterIndex(index) {
        var bulletItems = [];

        for (let i = index; i < this.lines.length; i++) {
            let line = this.lines[i];
            if (line && (line.startsWith('*') || line.startsWith('•'))) {
                // eslint-disable-next-line
                bulletItems.push(line.replace(/^\*+|\|+$/g, '').replace(/^\•+|\|+$/g, ''));
            } else {
                break;
            }
        }

        return bulletItems;
    }

    render() {
        let previousWasBulletItem = false;
        return (
            <>
                {this.lines.map((line, index) => {
                    var isBulletListItem = line.startsWith('*') || line.startsWith('•');
                    if (isBulletListItem && previousWasBulletItem) {
                        return false;
                    } else if (isBulletListItem) {
                        previousWasBulletItem = true;
                    } else {
                        previousWasBulletItem = false;
                    }

                    return isBulletListItem ? (
                        <ul className={this.props.wrapperClass} key={index}>
                            {this.getBulletListItemsAfterIndex(index).map((item, i) => (
                                <li key={i}>{item}</li>
                            ))}
                        </ul>
                    ) : (
                        <p key={index}>{line}</p>
                    );
                })}
            </>
        );
    }
}

export default TextWithBullets;
